import { createContext } from "react";

const ReducerContext = createContext({
  dispatch: ({ payload, type } = {}) => ({ payload, type }),
  state: {}
});

ReducerContext.displayName = "StateReducerContext";

export default ReducerContext;
